/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React from "react";
import produce from "immer";
import { Link } from "react-router-dom";
import { Loading } from "./AllReports";

const LocationssTable = ({ data, initialLoad }) => {
  return (
    <div className="contentTbl">
      <table className="overview" id="data-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Location Address</th>
            <th>City Address</th>
            <th>Geneva Review Enables</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>

        {initialLoad ? (
          <Loading />
        ) : data.length > 0 ? (
          <tbody>
            {data.map((item, index) => (
              <tr key={item?.id}>
                <td>{item?.name}</td>
                <td>{item?.addressLine1}</td>
                <td>{item?.city}</td>
                <td></td>
                <td></td>
                <td>
                  <div id={`view-btn-${index}`} className="show-options">
                    <Link to={`/locations3/${item?.id}`} className="btn">
                      View/Edit
                    </Link>
                    {/* <button className="btn btnUrgent">Esign</button> */}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        ) : null}
      </table>
      {data.length === 0 && !initialLoad ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 300,
            fontSize: 18,
          }}
        >
          No locations
        </div>
      ) : null}
    </div>
  );
};

export default LocationssTable;
